import { Record as ImmutableRecord } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
export const pickFromQuery = fieldName => query => {
  class QueryResults extends ImmutableRecord({
    data: undefined,
    error: undefined,
    loading: false,
    // @ts-expect-error immutable not playing nice with TS and apollo
    fetchMore: undefined
  }, 'QueryResults') {
    getResults() {
      return getIn(['data', fieldName, 'results'], this) || [];
    }
    getPaging() {
      return getIn(['data', fieldName, 'paging'], this) || {};
    }
  }
  return new QueryResults(query);
};